<template>
    <div class="flex flex-col gap-4">
        <div class="flex items-center justify-between">
            <div class="flex items-center gap-1">
                <span class="text-sm">{{ t('credits.label') }}</span>
                <PersonalCreditPopover />
            </div>
            <span class="text-sm">{{ totalAvailableCredits }}</span>
        </div>

        <!-- Projects 行 -->
        <div class="flex flex-col gap-2">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-1">
                    <span class="text-sm">{{ t('projects.label') }}</span>
                    <PersonalStoragePopover />
                </div>
                <span class="text-sm text-[#495973]">
                    {{ totalUsedProjectStorage }}/{{ totalProjectStorage }} MB
                </span>
            </div>
            <!-- 进度条 -->
            <div class="relative h-2 w-full overflow-hidden rounded-full bg-[#EBECF0]">
                <div
                    class="h-full rounded-full bg-gradient-to-r from-[#00C853] via-[#00BCD4] to-[#2196F3]"
                    :style="{ width: projectProgressPercentage + '%' }"
                ></div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import PersonalCreditPopover from './PersonalCreditPopover.vue';
import PersonalStoragePopover from './PersonalStoragePopover.vue';
import { useLsEditionUsage } from '../../../composables/use-ls-edition-usage';

const messages = {
    en: {
        credits: {
            label: 'Credits',
        },
        projects: {
            label: 'Projects',
        },
    },
    cn: {
        credits: {
            label: '积分',
        },
        projects: {
            label: '项目',
        },
    },
    jp: {
        credits: {
            label: 'ポイント',
        },
        projects: {
            label: 'プロジェクト',
        },
    },
    tw: {
        credits: {
            label: '積分',
        },
        projects: {
            label: '專案',
        },
    },
}

const { t } = useI18n({
    messages,
});

const { totalAvailableCredits, totalUsedProjectStorage, totalProjectStorage, projectProgressPercentage } = useLsEditionUsage();
</script>
